import {PLACEHOLDERS} from '../constants/ProfileSectionsKeys';

const replaceIfNotNull = (originalText, placeholder, value) => {
    if (value !== null && value !== undefined) {
        const regex = new RegExp(placeholder, 'g');

        return originalText.replace(regex, value);
    }
    return originalText;
};

const formatProfileDescription = (value, placeholders) => {
    let replacedText = value;

    Object.entries(placeholders).forEach(([key, value]) => {
        const placeholder = PLACEHOLDERS.find(p => p.id === key)?.value;
        if (placeholder) {
            replacedText = replaceIfNotNull(replacedText, placeholder, value);
        }
    });

    return replacedText;
}

export default formatProfileDescription;